import { DemographicQuestion, DemographicQuestionType, GameVisuals } from "../../../../gql/graphql";
import { DemographicResponse } from "../types";
import { DemographicNumberInput } from "./DemographicNumberInput";
import { DemographicRadioInput } from "./DemographicRadioInput";
import { DemographicMultiSelectInput } from "./DemographicMultiSelectInput";
import classNames from "classnames/bind";
import styles from "../../QuizGame.module.scss";

const cx = classNames.bind(styles);

interface DemographicQuestionRendererProps {
  question: DemographicQuestion;
  response: DemographicResponse;
  gameVisuals: GameVisuals;
  onChange: (response: Partial<DemographicResponse>) => void;
  questionIndex: number;
  totalQuestions: number;
}

export const DemographicQuestionRenderer = ({
  question,
  response,
  gameVisuals,
  onChange,
  questionIndex,
  totalQuestions,
}: DemographicQuestionRendererProps) => {
  const renderQuestionInput = () => {
    switch (question.questionType) {
      case DemographicQuestionType.NumberInput:
        return (
          <div className={styles.answersWrapper}>
            <DemographicNumberInput value={response.numberValue} gameVisuals={gameVisuals} onChange={onChange} />
          </div>
        );

      case DemographicQuestionType.Radio:
        return (
          <DemographicRadioInput
            options={question.answerOptions}
            selectedOptionIds={response.selectedOptionIds || []}
            onChange={onChange}
          />
        );

      case DemographicQuestionType.MultiSelect:
        return (
          <DemographicMultiSelectInput
            options={question.answerOptions}
            selectedOptionIds={response.selectedOptionIds || []}
            onChange={onChange}
          />
        );

      default:
        console.warn(`Unsupported question type: ${question.questionType}`);
        return null;
    }
  };

  return (
    <>
      <div className={styles.questionSection}>
        <div className={styles.gameHeader}>
          <div className={cx("questionProgress", "demographic")}>
            <div>Tell us more about you! (Optional)</div>
            <div>
              Question <span className={styles.currentQuestion}>{questionIndex}</span> of {totalQuestions}
            </div>
          </div>
        </div>

        <div className={styles.questionContent}>
          <h2 className={styles.questionText}>{question.questionText}</h2>
        </div>
      </div>

      {renderQuestionInput()}
    </>
  );
};
